// The submission list needs one request per submission to know its assessment, which
// takes minutes on a large exercise. Assessments only change through explicit actions
// (grading, revision), so the loaded map is kept per exercise for the session and
// entries are invalidated individually where those actions happen.
const cachedMaps: any = {};

// Returns the shared map object for this exercise. The list component mutates it in
// place, so everything written during a visit is still there on the next visit.
export const getAssessmentCache = (exerciseId: any) => {
  const key = String(exerciseId);
  if (!cachedMaps[key]) {
    cachedMaps[key] = {};
  }
  return cachedMaps[key];
};

// Drops one entry so the next visit of the list fetches it again. Called after a
// manual revision was saved, because that changes the assessment behind the entry.
export const invalidateAssessment = (exerciseId: any, submissionExerciseId: any) => {
  const key = String(exerciseId);
  if (cachedMaps[key]) {
    delete cachedMaps[key][submissionExerciseId];
  }
};
